module.exports = __webpack_public_path__ + "img/781h34Pm3zPO0VNft1h29s7k48P1665456733490.7514de63.png";